import React from 'react';

interface Props {
  color?: string;
  size?: number;
}

/**
 * QRコードアイコン（フッターナビ「出退勤QR」）
 * 管理画面 sidebar_qr.svg と統一
 */
const QrNavIcon: React.FC<Props> = ({ color = 'currentColor', size = 30 }) => (
  <svg
    viewBox="338 14 24 25"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect fill={color} x="350.91" y="32.39" width="1.72" height="1.72"/>
    <rect fill={color} x="355.85" y="32.39" width="1.72" height="1.72"/>
    <rect fill={color} x="353.38" y="29.98" width="1.72" height="1.72"/>
    <path fill={color} d="M356.8,28.99h-5.11c-.42,0-.76-.34-.76-.76s.34-.76.76-.76h5.11c.42,0,.76.34.76.76s-.34.76-.76.76Z"/>
    <path fill={color} d="M347.85,34.1h-4.19c-.67,0-1.22-.55-1.22-1.22v-4.19c0-.67.55-1.22,1.22-1.22h4.19c.67,0,1.22.55,1.22,1.22v4.19c0,.67-.55,1.22-1.22,1.22ZM343.96,32.58h3.59v-3.59h-3.59v3.59ZM347.85,28.99h0,0Z"/>
    <path fill={color} d="M347.85,25.6h-4.19c-.67,0-1.22-.55-1.22-1.22v-4.19c0-.67.55-1.22,1.22-1.22h4.19c.67,0,1.22.55,1.22,1.22v4.19c0,.67-.55,1.22-1.22,1.22ZM343.96,24.09h3.59v-3.59h-3.59v3.59ZM347.85,20.49h0,0Z"/>
    <path fill={color} d="M356.34,25.6h-4.19c-.67,0-1.22-.55-1.22-1.22v-4.19c0-.67.55-1.22,1.22-1.22h4.19c.67,0,1.22.55,1.22,1.22v4.19c0,.67-.55,1.22-1.22,1.22ZM352.44,24.09h3.59v-3.59h-3.59v3.59ZM356.34,20.49h0,0Z"/>
    <path fill={color} d="M339.76,21.64c-.42,0-.76-.34-.76-.76v-2.75c0-1.43,1.16-2.6,2.6-2.6h2.75c.42,0,.76.34.76.76s-.34.76-.76.76h-2.75c-.6,0-1.08.48-1.08,1.08v2.75c0,.42-.34.76-.76.76Z"/>
    <path fill={color} d="M360.24,21.64c-.42,0-.76-.34-.76-.76v-2.75c0-.6-.48-1.08-1.08-1.08h-2.75c-.42,0-.76-.34-.76-.76s.34-.76.76-.76h2.75c1.43,0,2.6,1.16,2.6,2.6v2.75c0,.42-.34.76-.76.76Z"/>
    <path fill={color} d="M344.35,37.54h-2.75c-1.43,0-2.6-1.16-2.6-2.6v-2.75c0-.42.34-.76.76-.76s.76.34.76.76v2.75c0,.6.48,1.08,1.08,1.08h2.75c.42,0,.76.34.76.76s-.34.76-.76.76Z"/>
    <path fill={color} d="M358.4,37.54h-2.75c-.42,0-.76-.34-.76-.76s.34-.76.76-.76h2.75c.6,0,1.08-.48,1.08-1.08v-2.75c0-.42.34-.76.76-.76s.76.34.76.76v2.75c0,1.43-1.16,2.6-2.6,2.6Z"/>
    <rect fill={color} x="344.9" y="21.43" width="1.72" height="1.72"/>
    <rect fill={color} x="353.38" y="21.43" width="1.72" height="1.72"/>
    <rect fill={color} x="344.9" y="29.93" width="1.72" height="1.72"/>
  </svg>
);

export default QrNavIcon;
